const PUSH_BILLS_BUFFER = (state, payload) => { state.billsBuffer.push(payload) }
const POP_BILLS_BUFFER = (state, payload) => { state.billsBuffer[payload] = 0 }
const RESET_BILLS_BUFFER = (state) => { state.billsBuffer = [] }

const SET_FETCHBILLS_IN_PROGRESS = (state, payload) => { state.fetchBillsInProgress = payload }
const RESET_FETCHBILLS_IN_PROGRESS = (state) => { state.fetchBillsInProgress = false }

const SET_REQUEST_ARRAY_STATUS = (state, payload) => { state.requestArrayStatus = payload }
const RESET_REQUEST_ARRAY_STATUS = (state) => { state.requestArrayStatus = [] }
const SET_INDEX_VALUE_REQUEST_ARRAY_STATUS = (state, payload) => { state.requestArrayStatus[payload.index] = payload.value }

const SET_PRODUCT_LIST = (state, payload) => { state.productList = payload }
const RESET_PRODUCT_LIST = (state) => { state.productList = [] }

const SET_REPORT_RELOAD_TIMEOUT = (state, payload) => { state.reportReloadTimeout = payload }
const RESET_REPORT_RELOAD_TIMEOUT = (state) => { state.reportReloadTimeout = [] }

const SET_TOTAL_LOCAL_PAID_BILL_ITEMS = (state, payload) => { state.totalLocalPaidBillItems = payload }
const RESET_TOTAL_LOCAL_PAID_BILL_ITEMS = (state) => { state.totalLocalPaidBillItems = 0 }

const SET_TOTAL_ONLINE_PAID_BILL_ITEMS = (state, payload) => { state.totalOnlinePaidBillItems = payload }
const RESET_TOTAL_ONLINE_PAID_BILL_ITEMS = (state) => { state.totalOnlinePaidBillItems = 0 }

const SET_TOTALS_PERSONS_COUNT = (state, payload) => { state.totalsPersonsCount = payload }
const RESET_TOTALS_PERSONS_COUNT = (state) => { state.totalsPersonsCount = 0 }

const PUSH_TO_TRANSFORMED_ITEMS = (state, payload) => { state.transformedItens.push(payload) }
const SET_TRANSFORMED_ITEMS = (state, payload) => { state.transformedItens = payload }
const RESET_TRANSFORMED_ITEMS = (state) => { state.transformedItens = [] }
const PUSH_FETCH_BILLS_FAILURE = (state, payload) => { state.fetchBillsFailures.push(payload) }
const RESET_FETCH_BILLS_FAILURES = (state) => { state.fetchBillsFailures = [] }
const UPDATE_TRANSFORMED_ITEMS = (state, item) => {
  var allItems = JSON.parse(JSON.stringify(state.transformedItens))
  const index = allItems.findIndex(r => r.hash === item.hash);
  if (index !== -1) {
    state.transformedItens.splice(index, 1, item);
  }
}
const UPDATE_AGENTS_CONDUCTORS_TRANSFORMED_ITEMS = (state, item) => {
  var allItems = JSON.parse(JSON.stringify(state.transformedItens))
  let transformedItensIndex = -1
  let itemIndex = -1

  Object.keys(allItems).forEach((dateBookingListIndex)=>{
    transformedItensIndex = dateBookingListIndex
    itemIndex = allItems[dateBookingListIndex].findIndex(i => i.hash.toUpperCase() == item.hash.toUpperCase());
    if (itemIndex !== -1) {
      state.transformedItens[transformedItensIndex][itemIndex].agents = item.agents
      state.transformedItens[transformedItensIndex][itemIndex].checkin = item.checkin
      return
    }
  })
}

const SET_SHOW_SPLASH = (state, payload) => { state.showSplash = payload }
const RESET_SHOW_SPLASH = (state) => { state.showSplash = true }

export default {
  PUSH_BILLS_BUFFER,
  POP_BILLS_BUFFER,
  RESET_BILLS_BUFFER,

  SET_FETCHBILLS_IN_PROGRESS,
  RESET_FETCHBILLS_IN_PROGRESS,

  SET_REQUEST_ARRAY_STATUS,
  RESET_REQUEST_ARRAY_STATUS,
  //UPDATE_INDEX_REQUEST_ARRAY_STATUS,
  SET_INDEX_VALUE_REQUEST_ARRAY_STATUS,

  SET_PRODUCT_LIST,
  RESET_PRODUCT_LIST,

  SET_TOTAL_LOCAL_PAID_BILL_ITEMS,
  RESET_TOTAL_LOCAL_PAID_BILL_ITEMS,

  SET_TOTAL_ONLINE_PAID_BILL_ITEMS,
  RESET_TOTAL_ONLINE_PAID_BILL_ITEMS,

  SET_TOTALS_PERSONS_COUNT,
  RESET_TOTALS_PERSONS_COUNT,

  PUSH_TO_TRANSFORMED_ITEMS,
  SET_TRANSFORMED_ITEMS,
  RESET_TRANSFORMED_ITEMS,
  PUSH_FETCH_BILLS_FAILURE,
  RESET_FETCH_BILLS_FAILURES,
  UPDATE_TRANSFORMED_ITEMS,
  UPDATE_AGENTS_CONDUCTORS_TRANSFORMED_ITEMS,

  SET_SHOW_SPLASH,
  RESET_SHOW_SPLASH,

  SET_REPORT_RELOAD_TIMEOUT,
  RESET_REPORT_RELOAD_TIMEOUT,
}
